import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Stack, FormInput, FormLabel, FormHelpText, FormFeedbackText, FormFieldControl, } from '@stepstone-genesis/components';
import { forwardRef, useState } from 'react';
export const Input = forwardRef(({ type, placeholder, formLabel, helpText, name, suffix, value, onChange, hasError, errorText, onBlur, dataTestId, autoComplete, onFocus, }, ref) => {
    const [isTouched, setIsTouched] = useState(true);
    const onChangeHandler = (e) => {
        onChange(e);
        setIsTouched(true);
    };
    const onBlurHandler = (e) => {
        onBlur(e, isTouched);
        setIsTouched(false);
    };
    return (_jsx(FormFieldControl, { isInvalid: hasError, children: _jsxs(Stack, { direction: 'vertical', spacing: 'spaceS', children: [_jsx(FormLabel, { children: formLabel }), helpText && _jsx(FormHelpText, { children: helpText }), _jsx(FormInput, { ref: ref, "data-testid": dataTestId, sx: { borderRadius: 'borderRadiusS' }, value: value, onChange: onChangeHandler, onBlur: onBlurHandler, onFocus: onFocus, type: type, placeholder: placeholder, name: name, size: ['medium'], suffix: suffix, isInvalid: hasError, autoComplete: autoComplete }), hasError && errorText && (_jsx(FormFeedbackText, { isInvalid: true, variant: "negative", children: errorText }))] }) }));
});
Input.displayName = 'Input';
//# sourceMappingURL=Input.js.map